$("body").on("click", ".swatchItem", function () {
  let isChecked = $(this).is(':checked');
  if (isChecked == true) {
    $(this).siblings('.add-on-product-note-wrp').slideDown();
  } else {
    $(this).siblings('.add-on-product-note-wrp').slideUp();
  }
});
$(document).ready(function () {
  $('.accordion-list > li > .answer').hide();
  $('.accordion-list > li h3').click(function () {
    if ($(this).parents('li').hasClass("active")) {
      $(this).parents('li').removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).parents('li').addClass("active").find(".answer").slideDown();
    }
    return false;
  });
  $("body").on("click", ".Custom-AddToCart2", function () {
    addOn();
    setTimeout(function () {
      console.log('button clicked')
      $('.product-btn-wrp .btnAddToCart').trigger("click");
    }, 1000);

  });
})

function addOn() {
  // Exit early if no add-on products container
  if ($('.add-on-products').length === 0) {
    return;
  }

  // Global/default quantity from main input
  const defaultQuantity = parseInt($('#Quantity').val(), 10) || 0;

  // The special ID that uses its own quantity field
  const SPECIAL_ID = 45087758024938;

  let items = [];

  $('.add-on-products').each(function () {
    const $container = $(this);
    const selectedInput = $container.children('input:checked');

    // Guard: ensure we have a checked input with an ID
    if (!selectedInput.length) return;
    const addOnDataID = parseInt(selectedInput.data('id'), 10);
    if (!addOnDataID) return;

    // Prepare the item object
    let item = {
      id: addOnDataID,
      quantity: defaultQuantity,
      properties: {}
    };

    // If this is the special add-on, try to read its own quantity
    if (addOnDataID === SPECIAL_ID) {
      const sizeTabs = document.querySelector('.dimension-size-tabs');
      const areaOutput = sizeTabs.querySelector('.area-output');
      var addonQty = 0;
      
      if(areaOutput && areaOutput.dataset.addonquantity){
         addonQty = parseInt(areaOutput.dataset.addonquantity, 10);
      }

      console.log(addonQty);

      // Use the addonQty if it’s a positive integer
      if (!isNaN(addonQty) && addonQty > 0) {
        item.quantity = addonQty;
      }
    }

    // Add other properties if present
    const addOnNote = $container.find('.add-on-note').val();
    if (addOnNote != null) {
      item.properties.Note = addOnNote;
    }

    const addonFile = $container.find("input[name='properties[thumbnail]']").val();
    if (addonFile) {
      item.properties.image = addonFile;
    }

    items.push(item);
    console.log('items', items)
  });

  // If there's nothing to add, skip the POST
  if (items.length === 0) {
    return;
  }

  console.log('adding to cart', items)

  // Submit to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => {
    if (!response.ok) throw new Error('Network response was not ok');
    return response.json();
  })
  .then(data => {
    console.log('added to cart', items);
    //window.location.href = '/cart';
  })
  .catch(error => {
    console.error('Failed to add add-ons to cart:', error);
    // Optional: show a user-friendly error message here
  });
}






//customized by kp 


// function addOn() {
//   if ($('.add-on-products').length === 0) {
//     return;
//   }

//   const defaultQuantity = parseInt($('#Quantity').val(), 10) || 0;
//   const SPECIAL_ID = 45087758024938;

//   let items = [];
//   let specialAddOnQty = 0;
//   let hasSpecialID = false;
//   let isSpecialMaxedOut = false;

//   $('.add-on-products').each(function () {
//     const $container = $(this);
//     const selectedInput = $container.children('input:checked');
//     if (!selectedInput.length) return;

//     const addOnDataID = parseInt(selectedInput.data('id'), 10);
//     if (!addOnDataID) return;

//     let quantity = defaultQuantity;

//     if (addOnDataID === SPECIAL_ID) {
//       hasSpecialID = true;

//       const sizeTabs = document.querySelector('.dimension-size-tabs');
//       const areaOutput = sizeTabs?.querySelector('.area-output');

//       if (areaOutput && areaOutput.dataset.addonquantity) {
//         specialAddOnQty = parseInt(areaOutput.dataset.addonquantity, 10) || 0;
//       }

//       // Simulate a max quantity check — modify this as needed
//       const maxAllowedQty = parseInt(areaOutput?.dataset.maxquantity || '0', 10);
//       if (!isNaN(maxAllowedQty) && specialAddOnQty >= maxAllowedQty) {
//         isSpecialMaxedOut = true;
//       }

//       if (!isNaN(specialAddOnQty) && specialAddOnQty > 0) {
//         quantity = specialAddOnQty;
//       }
//     }

//     // If special is maxed out and this is NOT the special ID, skip
//     if (isSpecialMaxedOut && addOnDataID !== SPECIAL_ID) {
//       return;
//     }

//     let item = {
//       id: addOnDataID,
//       quantity: quantity,
//       properties: {}
//     };

//     const addOnNote = $container.find('.add-on-note').val();
//     if (addOnNote != null) {
//       item.properties.Note = addOnNote;
//     }

//     const addonFile = $container.find("input[name='properties[thumbnail]']").val();
//     if (addonFile) {
//       item.properties.image = addonFile;
//     }

//     items.push(item);
//   });

//   if (items.length === 0) {
//     return;
//   }

//   console.log('adding to cart', items);

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({ items: items })
//   })
//     .then(response => {
//       if (!response.ok) throw new Error('Network response was not ok');
//       return response.json();
//     })
//     .then(data => {
//       console.log('added to cart', items);
//     })
//     .catch(error => {
//       console.error('Failed to add add-ons to cart:', error);
//     });
// }








// function addOn() {
//   if ($('.add-on-products').length === 0) return;

//   const defaultQuantity = parseInt($('#Quantity').val(), 10) || 0;
//   const SPECIAL_ID = 45087758024938;

//   let addonQty = 0;
//   const areaOutput = document.querySelector('.dimension-size-tabs .area-output');
//   if (areaOutput?.dataset.addonquantity) {
//     addonQty = parseInt(areaOutput.dataset.addonquantity, 10) || 0;
//   }
//   console.log('addonQty:', addonQty);

//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       let currentSpecialQty = cart.items.reduce((sum, it) => {
//         if (it.id === SPECIAL_ID) sum = it.quantity;
//         return sum;
//       }, 0);
//       console.log('currentSpecialQty:', currentSpecialQty);

//       if (addonQty > 0 && currentSpecialQty >= addonQty) {
//         console.log(`Max reached (${currentSpecialQty}/${addonQty}), exiting without adding.`);
//         return;
//       }

//       let items = [];
//       $('.add-on-products').each(function () {
//         const $c = $(this);
//         const sel = $c.children('input:checked');
//         if (!sel.length) return;
//         const id = parseInt(sel.data('id'), 10);
//         if (!id) return;

//         console.log('Selected add-on ID:', id);

//         let qty = defaultQuantity;
//         if (id === SPECIAL_ID && addonQty > 0) qty = addonQty;

//         items.push({
//           id,
//           quantity: qty,
//           properties: {
//             ...(($c.find('.add-on-note').val() != null) && { Note: $c.find('.add-on-note').val() }),
//             ...(($c.find("input[name='properties[thumbnail]']").val()) && { image: $c.find("input[name='properties[thumbnail]']").val() })
//           }
//         });
//       });

//       console.log('Prepared items array:', JSON.stringify(items));

//       if (items.length === 0) {
//         console.log('No items to add.');
//         return;
//       }

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ items })
//       })
//         .then(r => r.ok ? r.json() : Promise.reject(r.status))
//         .then(data => console.log('Add-to-cart response:', data))
//         .catch(e => console.error('Add to cart failed:', e));
//     })
//     .catch(e => console.error('Cart fetch failed:', e));
// }

// function addOn() {
//   if ($('.add-on-products').length === 0) return;

//   const defaultQuantity = parseInt($('#Quantity').val(), 10) || 0;
//   const SPECIAL_ID = 45087758024938;

//   // Get the add-on quantity from the size tab (for SPECIAL_ID)
//   let addonQty = 0;
//   const sizeTabs = document.querySelector('.dimension-size-tabs');
//   const areaOutput = sizeTabs?.querySelector('.area-output');
//   if (areaOutput && areaOutput.dataset.addonquantity) {
//     addonQty = parseInt(areaOutput.dataset.addonquantity, 10) || 0;
//   }

//   // First get cart contents
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       let currentSpecialQty = 0;

//       // Check if SPECIAL_ID is already in cart
//       cart.items.forEach(item => {
//         if (item.id === SPECIAL_ID) {
//           currentSpecialQty = item.quantity;
//         }
//       });

//       // If SPECIAL_ID is in the cart but its quantity has reached max, don't add add-ons
//       if (addonQty > 0 && currentSpecialQty >= addonQty) {
//         console.log(`SPECIAL_ID already has max quantity (${currentSpecialQty}/${addonQty}) in cart. Skipping all add-ons.`);
//         return;
//       }

//       let itemsToAdd = [];

//       $('.add-on-products').each(function () {
//         const $container = $(this);
//         const selectedInput = $container.children('input:checked');

//         if (!selectedInput.length) return;
//         const addOnDataID = parseInt(selectedInput.data('id'), 10);
//         if (!addOnDataID) return;

//         let item = {
//           id: addOnDataID,
//           quantity: defaultQuantity,
//           properties: {}
//         };

//         // For SPECIAL_ID override quantity
//         if (addOnDataID === SPECIAL_ID && addonQty > 0) {
//           item.quantity = addonQty;
//         }

//         const addOnNote = $container.find('.add-on-note').val();
//         if (addOnNote != null) {
//           item.properties.Note = addOnNote;
//         }

//         const addonFile = $container.find("input[name='properties[thumbnail]']").val();
//         if (addonFile) {
//           item.properties.image = addonFile;
//         }

//         itemsToAdd.push(item);
//       });

//       // If nothing to add, exit
//       if (itemsToAdd.length === 0) {
//         console.log("No valid add-ons to add to cart.");
//         return;
//       }

//       console.log('Adding items to cart:', itemsToAdd);

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ items: itemsToAdd })
//       })
//       .then(response => {
//         if (!response.ok) throw new Error('Add to cart failed');
//         return response.json();
//       })
//       .then(data => {
//         console.log('Add-ons successfully added to cart');
//         // Optional: window.location.href = '/cart';
//       })
//       .catch(error => {
//         console.error('Error adding add-ons:', error);
//       });

//     })
//     .catch(err => {
//       console.error('Error fetching cart:', err);
//     });
// }

